import React, { useState } from "react";
import './OrderDetailsCard.css'
import OrderDetailsIcon from "./OrderDetailsIcon";
import moment from "moment/moment";

const OrderDetailsCard = ({ TrackingData }) => {
    return (
        <div className="order-card">
            <div className="order-card-content">
                <div className="order-header">
                    <div className="d-flex align-items-center gap-3">
                        <a href="#">
                            <OrderDetailsIcon />
                        </a>
                        <h4 className="order-title">Order Details</h4>
                    </div>
                    <div>
                        <span className="font14">Status: </span>
                        <span className="text-capitalize" style={{ color: '#1EA231' }}>{TrackingData?.status}</span>
                    </div>
                </div>

                <div className="order-info">
                    <div className="order-row">
                        <span className="order-label">Order ID</span>
                        <span className="order-value">#{TrackingData?.customer_order_number}</span>
                    </div>
                    <div className="order-row">
                        <span className="order-label">Order Placed On</span>
                        <span className="order-value">{moment(TrackingData?.order_date).format('DD MMM YYYY')}</span>
                    </div>
                    <div className="order-row">
                        <span className="order-label">Order Total</span>
                        <span className="order-value">{TrackingData?.invoice_amount}</span>
                    </div>
                    <div className="order-row">
                        <span className="order-label">Payment Method</span>
                        <span className="order-value">{TrackingData?.payment_type}</span>
                    </div>
                    {/* Extras */}
                    <div className="order-row">
                        <span className="order-label">Order Type</span>
                        <span className="order-value">{TrackingData?.order_type}</span>
                    </div>
                    <div className="order-row">
                        <span className="order-label">Courier Partner</span>
                        <span className="order-value">{TrackingData?.courier || TrackingData?.courier_partner}</span>
                    </div>
                    <div className="order-row">
                        <span className="order-label">Expected Delivery Date</span>
                        <span className="order-value">{moment(TrackingData?.other_details?.expected_delivery_date).format('DD MMM YYYY')}</span>
                    </div>
                    {/* <div className="order-row">
                        <span className="order-label">Name of The Buyer</span>
                        <span className="order-value">Test User</span>
                    </div>
                    <div className="order-row">
                        <span className="order-label">Phone Number</span>
                        <span className="order-value">+91-9999999999</span>
                    </div>
                    <div className="order-row">
                        <span className="order-label">Address</span>
                        <span className="order-value">
                            Shipease Technologies, sec 66, Gurugram, Haryana
                        </span>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default OrderDetailsCard;
